module.exports = __webpack_public_path__ + "static/media/dashboard-teal.380189c5.svg";